import * as React from 'react'

import {
  TidalCustomerPreview,
  TidalNotAddedReferralPreview,
  TidalEmployeePreview,
  TidalOtherPreview,
  TidalNoReferralPreview,
} from '.'
import { PreviewVariants } from './typings'
import { IReferral } from '@sales-center/common'

type Props = {
  billToCardMaxWidth?: string
  billToCardWidth?: string
  employeeListStatus: 'pending' | 'success' | 'fail'
  referral?: IReferral
  userListStatus: 'pending' | 'success' | 'fail'
  variant: PreviewVariants
  onButtonClick?: () => void
  mainVariant?: 'classic' | 'gray'
}

export function TidalReferralPreview(props: Props) {
  const {
    billToCardMaxWidth,
    billToCardWidth,
    employeeListStatus,
    referral,
    variant,
  } = props

  if (!referral) return <TidalNotAddedReferralPreview />

  switch (referral.referralType) {
    case 'Customer':
      return (
        <TidalCustomerPreview
          billToCardWidth={billToCardWidth}
          billToCardMaxWidth={billToCardMaxWidth}
          referral={referral}
          variant={variant}
        />
      )
    case 'Employee':
      return (
        <TidalEmployeePreview
          employeeListStatus={employeeListStatus}
          referral={referral}
        />
      )
    case 'Other':
      return <TidalOtherPreview referral={referral} />

    case 'None':
      return <TidalNoReferralPreview referral={referral} />
    default:
      return <TidalNotAddedReferralPreview />
  }
}
